import React from "react";
import { Button } from 'antd';

import styles from "./contact.module.less";

const Contact = () => (
  <div className={styles.content}>
    <div className={styles.wrapper}>
      <Button
        href="mailto:info@beeonquest.com?subject=Request for demo"
        className={styles.button}
        onClick={(e) => e.target.blur()}
      >
        Contact us for demo
      </Button>
      <div className={styles.infoContainer}>
        <div className={styles.info}>
          <div className={styles.phoneImage} />
          <a href="tel:18334048484" className={styles.mailAddress}>+1-833-404-8484</a>
        </div>
        <div className={styles.info}>
          <div className={styles.mailImage} />
          <a href="mailto:info@beeonquest.com?subject=Request for support" target="_blank" rel="noopener noreferrer" className={styles.mailAddress}>info@beeonquest.com</a>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
